import { z } from "zod";
import { privateStorage } from "@/lib/privateStorage";
import { onSessionChange } from "@/lib/api/session";
import { simulationV3DraftSchema } from "../model/draftSchema";

export const DRAFT_KEY = "oransim_v3_simulation_draft";
export const RECENT_TASK_KEY = "oransim_v3_recent_task_id";
export const OPERATION_LEDGER_KEY = "oransim_v3_pending_operations";
export const MAX_DRAFT_BYTES = 2_000_000;
export const storedDraftSchema = z.object({
  version: z.literal(1),
  values: simulationV3DraftSchema,
}).strict();

export const operationEntrySchema = z.object({
  kind: z.enum(["create", "retry"]),
  fingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  key: z.string().regex(/^simulation-v3-(create|retry)-[a-zA-Z0-9-]+$/).max(200),
}).strict();
export const operationLedgerSchema = z.object({
  version: z.literal(1),
  entries: z.array(operationEntrySchema).max(128),
}).strict();

let volatileDraft = false;
let volatileRecent = false;
let operationMemoryOnly = false;
onSessionChange(() => { volatileDraft = false; volatileRecent = false; operationMemoryOnly = false; });

export function markDraftVolatile(value: boolean): void {
  volatileDraft = value;
}

export function markRecentVolatile(value: boolean): void {
  volatileRecent = value;
}

export function markOperationMemoryOnly(value: boolean): void {
  operationMemoryOnly = value;
}

export function isSimulationRouteReloadSafe(): boolean {
  if (volatileDraft || volatileRecent || operationMemoryOnly) return false;
  try {
    const rawDraft = privateStorage.getItem(DRAFT_KEY);
    privateStorage.getItem(RECENT_TASK_KEY);
    const rawLedger = privateStorage.getItem(OPERATION_LEDGER_KEY);
    const draftSafe = rawDraft === null || (rawDraft.length <= MAX_DRAFT_BYTES
      && storedDraftSchema.safeParse(JSON.parse(rawDraft)).success);
    const ledgerSafe = rawLedger === null || (rawLedger.length <= 100_000
      && operationLedgerSchema.safeParse(JSON.parse(rawLedger)).success);
    return draftSafe && ledgerSafe;
  } catch {
    return false;
  }
}
